import { render, staticRenderFns } from "./report-box.vue?vue&type=template&id=cce28a62"
import script from "./report-box.vue?vue&type=script&lang=ts"
export * from "./report-box.vue?vue&type=script&lang=ts"
import style0 from "./report-box.vue?vue&type=style&index=0&id=cce28a62&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cce28a62')) {
      api.createRecord('cce28a62', component.options)
    } else {
      api.reload('cce28a62', component.options)
    }
    module.hot.accept("./report-box.vue?vue&type=template&id=cce28a62", function () {
      api.rerender('cce28a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/report-box/report-box.vue"
export default component.exports